import viewPage from './../component/viewPage.vue'
export default {
  className: 'feedback',
  fields: [
    {
      // 类型
      name: 'type'
    },
    {
      // 反馈人
      name: 'user',
      listWhere: (where) => {
        where.status = 'ordinary'
      }
    },
    {
      // 内容
      name: 'content'
    },
    {
      // 截图
      name: 'picture'
    },
    {
      // 联系方式
      name: 'contactWay'
    }
  ],
  search: [
    'type',
    'user'
  ],
  action: {
    export: false,
    create: false,
    edit: false,
    view: {
      type: 'row',
      text: '查看',
      component: viewPage
    }
  }
}
